import { LayoutHOC } from 'base/ui/layout/layout';
import { createProductDetail } from './productDetail';

export const createProductDeTailPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createProductDetail());
};
